
export default function Testimonials() {
  const testimonials = [
    {
      name: '佐藤 美咲',
      age: 28,
      course: '基礎料理コース',
      image: 'https://public.readdy.ai/ai/img_res/ece786bc69527a786b48926c9503febf.jpg',
      comment: '料理が全くできなかった私でも、3ヶ月で家族に喜ばれる料理が作れるようになりました。先生方の丁寧な指導に感謝しています。'
    },
    {
      name: '田中 健太',
      age: 35,
      course: 'プロフェッショナルコース',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20Japanese%20man%20in%20his%20mid%20thirties%20with%20short%20hair%20wearing%20chef%20uniform%20against%20clean%20white%20background%20with%20professional%20lighting%20showing%20determined%20expression&width=400&height=400&seq=testimonial2&orientation=squarish',
      comment: 'レストラン開業の夢を叶えるため受講しました。プロの技術を基礎から学べ、今では自分の店を持つことができました。'
    },
    {
      name: '鈴木 由美',
      age: 42,
      course: '製菓・製パンコース',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20Japanese%20woman%20in%20her%20early%20forties%20with%20warm%20smile%20wearing%20apron%20against%20clean%20white%20background%20with%20soft%20natural%20lighting%20showing%20happy%20joyful%20expression&width=400&height=400&seq=testimonial3&orientation=squarish',
      comment: 'お菓子作りが趣味でしたが、こちらで本格的に学んでから、友人からオーダーをいただくようになりました。'
    },
    {
      name: '高橋 翔太',
      age: 31,
      course: '世界の料理コース',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20friendly%20Japanese%20man%20in%20his%20early%20thirties%20with%20casual%20style%20wearing%20casual%20shirt%20against%20clean%20white%20background%20with%20natural%20lighting%20showing%20relaxed%20smile&width=400&height=400&seq=testimonial4&orientation=squarish',
      comment: '世界各国の料理を学べるのが魅力的でした。今では家で本格的なイタリアンやフレンチを作れるようになりました。'
    },
    {
      name: '伊藤 麻衣',
      age: 26,
      course: 'オンラインレッスン',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20Japanese%20woman%20in%20his%20mid%20twenties%20with%20shoulder%20length%20hair%20wearing%20stylish%20blouse%20against%20clean%20white%20background%20with%20soft%20professional%20lighting%20showing%20confident%20bright%20smile&width=400&height=400&seq=testimonial5new&orientation=squarish',
      comment: '地方在住でも受講できるオンラインレッスンが便利です。自宅のキッチンで学べるので、すぐに実践できます。'
    },
    {
      name: '山本 直樹',
      age: 45,
      course: '基礎料理コース',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20mature%20Japanese%20man%20in%20his%20mid%20forties%20with%20professional%20appearance%20wearing%20business%20casual%20against%20clean%20white%20background%20with%20soft%20lighting%20showing%20confident%20smile&width=400&height=400&seq=testimonial6&orientation=squarish',
      comment: '定年後の趣味として始めましたが、今では料理が生きがいになっています。同じ趣味の仲間もできました。'
    }
  ];

  return (
    <section id="testimonials" className="py-20 md:py-32 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">お客様の声</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            受講生の皆様から寄せられた喜びの声をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h3 className="font-bold text-gray-800">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.age}歳 / {testimonial.course}</p>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-600 leading-relaxed">{testimonial.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
